/**
 * The HUD score counts up to its new value instead of jumping (a classic
 * arcade touch). Pure: the value is a function of the ticker and the time.
 */

export const TICK_MS = 550;

export interface ScoreTicker {
  from: number;
  to: number;
  /** Time (ms, any clock) the count-up started. */
  startedAt: number;
}

export const tickerAt = (value: number, now: number): ScoreTicker => ({ from: value, to: value, startedAt: now });

/** Cubic ease-out: fast at first, settling gently on the final number. */
const easeOut = (t: number) => 1 - (1 - t) ** 3;

/** The number to show at `now` (whole points). */
export function tickerValue(ticker: ScoreTicker, now: number): number {
  const t = Math.min(1, Math.max(0, (now - ticker.startedAt) / TICK_MS));
  return Math.round(ticker.from + (ticker.to - ticker.from) * easeOut(t));
}

/** Count towards a new target, starting from whatever is on screen right now. */
export function retarget(ticker: ScoreTicker, target: number, now: number): ScoreTicker {
  if (target === ticker.to) return ticker;
  return { from: tickerValue(ticker, now), to: target, startedAt: now };
}

